export const API_URL =
  'https://s1.box.mokyun.com/e96e30c7-cbcb-4d4d-908b-1a8fad99d25f'; // mobox的唯一ID baidu-online-dev
export const BASE_URI = '';

/**
 * 即将弃用[2020/10/24]
 * @see @/utils/upload.ts
 */
// export const BASE_UPLOAD_URL = 'https://api.mokyun.com/upload/v3/'; // 默认是墨客云主CDN空间，如需指定bucket（前往七牛云配置），则https://api.mokyun.com/upload/v3/?bucket=xxx
// export const BASE_RESOURCE_URL = 'https://cdn1-open.mokyun.com/'; // 如指定了bucket，则资源地址需要匹配bucket域名（前往七牛云配置）

export const APPID = ''; // 公众号APPID

export const WEBSITE_TITLE = 'MokYun APP';

export const PUBLISH_DOMAIN = 'maker.jit.mokyun.com'; // 发布地址
